export default "__VITE_ASSET__35738452__"